import { ComponentProps, FC } from 'react';

import { AnimatePresence, motion } from 'framer-motion';

import { easeOutCubic } from '@ui-furniture/lib/utils/easings';

import { ButtonGrid } from './button-grid';

export const ExpandableButtonGrid: FC<
  {
    isCollapsed: boolean;
  } & ComponentProps<typeof ButtonGrid>
> = ({ isCollapsed, ...rest }) => (
  <motion.div
    layout
    animate={{ height: isCollapsed ? 0 : 'unset' }}
    transition={{ ease: easeOutCubic }}
  >
    <AnimatePresence>
      {!isCollapsed ? <ButtonGrid {...rest} /> : null}
    </AnimatePresence>
  </motion.div>
);
